import { NsTheme } from "@shared/EDS/ns-eds-types";
import { SBDActionStyle, SBDActionStylePerTrainUnitKind, SBDActionThemedStyles } from "./types";
import { typedColorToString } from "@shared/EDS/typedColorToString";
import { TrainUnitKind as TrainUnitKindCode } from "@opstel/query/models/planTrainUnit";

// The SBDActionStylePerTrainUnitKind objects are used to determine the colors of the SBDAction component.
// The colors are determined by the train unit kind and the theme.
// Not all colors are known at this time, so in future development, more colors can be added to the objects.
const trackOccupationStyleLight: SBDActionStylePerTrainUnitKind = {
  SNG: { backgroundColor: "#0063d3", color: "contentInverse", backgroundColorHover: "#005eca" },
  VIRM: {
    backgroundColor: "yellow500",
    color: "contentEmphasis",
    backgroundColorHover: "yellow500",
  },
  ICM: { backgroundColor: "green500", color: "contentInverse" },
  SLT: { backgroundColor: "purple500", color: "contentInverse" },
  FLIRT: { backgroundColor: "pink500", color: "contentInverse" },
  "FLIRT FFF": { backgroundColor: "pink500", color: "contentInverse" },
  DDZ: { backgroundColor: "teal600", color: "contentInverse" },
  ICR: { backgroundColor: "orange500", color: "contentInverse" },
  ICNG: { backgroundColor: "yellow800", color: "contentInverse" },
  ICNG25: { backgroundColor: "yellow800", color: "contentInverse" },
  ICNGB25: { backgroundColor: "yellow800", color: "contentInverse" },
  "SW7-15V": { backgroundColor: "teal400", color: "contentInverse" },
  "SW7-25KV": { backgroundColor: "teal400", color: "contentInverse" },
  "SW9-15V": { backgroundColor: "teal400", color: "contentInverse" },
  "SW9-25KV": { backgroundColor: "teal400", color: "contentInverse" },
  "SWB7-25KV": { backgroundColor: "teal400", color: "contentInverse" },
  FreightTrain: { backgroundColor: "gray400", color: "contentInverse" },
  ThirdParty: { backgroundColor: "gray400", color: "contentInverse" },
  "Unknown NS": { backgroundColor: "gray700", color: "contentInverse" },
  "Unknown 3rd party": { backgroundColor: "gray400", color: "contentInverse" },
};

const trackOccupationStyleDark: SBDActionStylePerTrainUnitKind = {
  SNG: { backgroundColor: "#0063d3", color: "contentInverse" },
  VIRM: { backgroundColor: "yellow500", color: "contentInverse" },
  ICM: { backgroundColor: "green400", color: "contentInverse" },
  SLT: { backgroundColor: "purple300", color: "contentInverse" },
  FLIRT: { backgroundColor: "pink400", color: "contentInverse" },
  "FLIRT FFF": { backgroundColor: "pink400", color: "contentInverse" },
  DDZ: { backgroundColor: "teal200", color: "contentInverse" },
  ICR: { backgroundColor: "orange400", color: "contentInverse" },
  ICNG: { backgroundColor: "yellow100", color: "contentInverse" },
  ICNG25: { backgroundColor: "yellow100", color: "contentInverse" },
  ICNGB25: { backgroundColor: "yellow100", color: "contentInverse" },
  "SW7-15V": { backgroundColor: "teal500", color: "contentInverse" },
  "SW7-25KV": { backgroundColor: "teal500", color: "contentInverse" },
  "SW9-15V": { backgroundColor: "teal500", color: "contentInverse" },
  "SW9-25KV": { backgroundColor: "teal500", color: "contentInverse" },
  "SWB7-25KV": { backgroundColor: "teal500", color: "contentInverse" },
  FreightTrain: { backgroundColor: "gray500", color: "contentInverse" },
  ThirdParty: { backgroundColor: "gray500", color: "contentInverse" },
  "Unknown NS": { backgroundColor: "gray200", color: "contentInverse" },
  "Unknown 3rd party": { backgroundColor: "gray500", color: "contentInverse" },
};

const sbdActionThemedStyles: SBDActionThemedStyles = {
  dark: trackOccupationStyleDark,
  light: trackOccupationStyleLight,
};

export function getSBDActionStyle(
  trainUnitKind: TrainUnitKindCode,
  theme: NsTheme,
): SBDActionStyle {
  const style = sbdActionThemedStyles[theme.name][trainUnitKind];

  const backgroundColor = typedColorToString(style.backgroundColor, theme);
  const color = typedColorToString(style.color, theme);
  const backgroundColorHover = style.backgroundColorHover
    ? typedColorToString(style.backgroundColorHover, theme)
    : backgroundColor;
  const colorHover = style.colorHover ? typedColorToString(style.colorHover, theme) : color;

  return {
    backgroundColor,
    color,
    backgroundColorHover,
    colorHover,
  };
}
